import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	noDateSet: {
		id: 'polaris-ideas.view-controls.config-timeline.date-picker.no-date-set',
		defaultMessage: 'No date set',
		description: 'Message for non date set',
	},
});
